exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* START EVOQ COLOR PALETTE */\n/* END EVOQ COLOR PALETTE */\n/* START ATTENTION COLORS */\n/* END ATTENTION COLORS */\n/* SVG HOVER STATES */\nsvg {\n  fill: #C8C8C8;\n}\nsvg:hover {\n  fill: #6F7273;\n}\nsvg:active {\n  fill: #1E88C3;\n}\n/* END SVG HOVER STATES */\n._1movAFl7s68q4BRi9VcTia > .dnn-grid-cell {\n  margin-bottom: 20px;\n}\n._1movAFl7s68q4BRi9VcTia .no-appearance-items {\n  width: 100%;\n  font-weight: bold;\n  padding: 13px 20px;\n  box-sizing: border-box;\n}\n", ""]);

// Exports
exports.locals = {
	"moduleContainer": "_1movAFl7s68q4BRi9VcTia"
};